<mwe-modal [model]="popupModel()">
  <h1 class="h4">{{ 'products.cancellation.title' | translate }}</h1>
  <h2 class="h5 mb-4">{{ 'products.cancellation.subtitle' | translate }}</h2>

  <div class="row g-4">
    @if (hasStromGasWaerme()) {
      <div class="col-lg-6">
        <mwe-clickable-products-card
          (cardClicked)="startDefaultCancellation()"
          [categories]="stromGasWaermeCategories()"
          [hasAutoFocus]="true"
          [textNodeType]="'h3'"
          dataTest="cancel-products-default"
          ariaTitle="move-out.title"
        >
          @if (hasStromGas()) {
            <p class="text--legal" [class.mb-1]="hasWaerme()" [class.mb-0]="!hasWaerme()">
              @if (hasWaerme()) {
                <span class="fw-semibold mb-0">{{ 'products.cancellation.legalText.stromGas' | translate }}</span>
              }
              {{ stromCompany }}
            </p>
          }
          @if (hasWaerme()) {
            <p class="text--legal mb-0">
              @if (hasStromGas()) {
                <span class="fw-semibold">{{ 'products.cancellation.legalText.waerme' | translate }}</span>
              }
              {{ waermeCompany }}
            </p>
          }
        </mwe-clickable-products-card>
      </div>
    }

    @if (hasEmobility()) {
      <div class="col-lg-6">
        <mwe-clickable-products-card
          (cardClicked)="startEmobCancellation()"
          [categories]="emobilityCategories()"
          [textNodeType]="'h3'"
          dataTest="cancel-products-emobility"
          ariaTitle="emobCancellation.title"
        >
          <p class="text--legal mb-0">{{ emobilityCompany }}</p>
        </mwe-clickable-products-card>
      </div>
    }

    @if (hasInternetTelevision()) {
      <div class="col-lg-6">
        <mwe-clickable-products-card
          [categories]="internetTelevisionCategories()"
          [textNodeType]="'h3'"
          [clickable]="false"
          dataTest="cancel-products-internet"
        >
          <p class="text--legal mb-3">{{ internetCompany }}</p>
          <p class="mb-3">{{ 'products.cancellation.internet.text' | translate }}</p>
          <p
            class="mb-0"
            [innerHTML]="
              'products.cancellation.internet.link'
                | translate: { link, products: internetTelevisionProductsString() }
                | addLinkImage
                | safeHtml
            "
          ></p>
        </mwe-clickable-products-card>
      </div>
    }
  </div>
</mwe-modal>
